"use strict";

angular.module("customer")
.component("catalogEntryPrice", {
    templateUrl: require("./catalog-entry-price.component.html"),
    controllerAs: "catalogEntryPriceCtrl",
    bindings: {
        catalogEntry: "<",
        catalogEntryVariant: "<?",
        alignRight: "<?",
        showRebate: "<",
        isVariableMeasure: "<",
        isProductVariant: "<?"
    }
});



//////////////////
// WEBPACK FOOTER
// ./customer/app-core/catalog-entry-price/catalog-entry-price.component.js
// module id = 855
// module chunks = 0